import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientesService } from 'src/app/services/clientes.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { environment } from '../../../environments/environment';
import { Ng2IzitoastService } from 'ng2-izitoast';

@Component({
  selector: 'app-seleccionar-detalles',
  templateUrl: './seleccionar-detalles.component.html',
  styleUrls: ['./seleccionar-detalles.component.scss']
})
export class SeleccionarDetallesComponent implements OnInit {
  environment = environment.BASE_URL
  currentGrupo:any;
  currentCliente:any;
  currentPaquete:any;
  data:any;

  respuestaGet:any;
  configuracionPaquete:any;

  seleccionesCliente:any;
  elementosPendientes:any;

  constructor(private _plataforma:ClientesService, private _activatedRoute: ActivatedRoute, 
    private _paquetes:PaquetesService, private modalService: NgbModal, private iziToast:Ng2IzitoastService, 
    private router: Router) { }

  ngOnInit(): void {
    this.currentGrupo = this._activatedRoute.snapshot.paramMap.get('grupo')
    this.currentCliente = this._activatedRoute.snapshot.paramMap.get('cliente')
    this.currentPaquete = this._activatedRoute.snapshot.paramMap.get('paquete')
    this.getConfiguracionPaquete();
    this.getSeleccionesCliente();
  }

  getConfiguracionPaquete(){
    this.data = {
      'paquete': this.currentPaquete,
    }
    this._plataforma.getConfiguracionPaquete(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.configuracionPaquete = this.respuestaGet.content;
          this.elementosPendientes = this.configuracionPaquete.length;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getSeleccionesCliente(){
    this.data = {
      'cliente': this.currentCliente,
    }

    this._plataforma.getSeleccionesCliente(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.seleccionesCliente = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  async closeSesion() {
    await localStorage.removeItem('token');
    await this.router.navigate(['/']);
  }
}
